import * as React from "react";
import { Col, Row } from "components/bootstrap";
import { DocumentTitle, Link, PageHeader } from "components/common";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import AIFeaturesStatusAlerts from "ai-management/components/AIFeaturesStatusAlerts";
import usePermissions from "hooks/usePermissions";
import AIManagementRoutes from "ai-management/Routes";
import { PAGE_NAVIGATION_TITLE as AI_MANAGEMENT_TITLE } from "ai-management/AIManagementPageNavigation";
import columnRenderers from "./AgentWorkflows/ColumnRenderers";
import { ADDITIONAL_ATTRIBUTES, DEFAULT_LAYOUT } from "./AgentWorkflows/Constants";
import useWorkflowDefinitions from "./AgentWorkflows/hooks/useWorkflowDefinitions";
import AgentWorkflowPageNavigation from "./AgentWorkflowPageNavigation";
const AgentWorkflowsPage = () => {
  const { fetchWorkflowDefinitions, keyFn } = useWorkflowDefinitions();
  const { isPermitted } = usePermissions();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "AI Agent Workflows" }, /* @__PURE__ */ React.createElement(AgentWorkflowPageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: "AI Agent Workflows" }, /* @__PURE__ */ React.createElement("span", null, "AI agent workflows run recurring checks across your security data and report what they find. Enable or disable workflows, and change their configuration. Workflows use the model provider configured on the", " ", isPermitted("agent_workflow:manage") ? /* @__PURE__ */ React.createElement(Link, { to: AIManagementRoutes.MODEL_PROVIDERS }, AI_MANAGEMENT_TITLE) : AI_MANAGEMENT_TITLE, " ", "page.")), /* @__PURE__ */ React.createElement(AIFeaturesStatusAlerts, null), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "AI agent workflows",
      tableLayout: DEFAULT_LAYOUT,
      fetchEntities: fetchWorkflowDefinitions,
      keyFn,
      columnRenderers,
      additionalAttributes: ADDITIONAL_ATTRIBUTES,
      entityAttributesAreCamelCase: false,
      noPageSizeSelect: true
    }
  ))));
};
export default AgentWorkflowsPage;
